import case1img1 from '../images/cases/1/1.png';
import case1img2 from '../images/cases/1/2.png';
import case1img3 from '../images/cases/1/3.png';

import case2img1 from '../images/cases/2/1.png';
import case2img2 from '../images/cases/2/2.png';
import case2img3 from '../images/cases/2/3.png';

import case3img1 from '../images/cases/3/1.png';
import case3img2 from '../images/cases/3/2.png';
import case3img3 from '../images/cases/3/3.png';

import case4img1 from '../images/cases/4/1.png';
import case4img2 from '../images/cases/4/2.png';
import case4img3 from '../images/cases/4/3.png';

import case5img1 from '../images/cases/5/1.png';

import case6img1 from '../images/cases/6/1.png';
import case6img2 from '../images/cases/6/2.png';
import case6img3 from '../images/cases/6/3.png';

import case7img1 from '../images/cases/7/1.png';
import case7img2 from '../images/cases/7/2.png';
import case7img3 from '../images/cases/7/3.png';

import case8img1 from '../images/cases/8/1.png';
import case8img2 from '../images/cases/8/2.png';
import case8img3 from '../images/cases/8/3.png';

import case9img1 from '../images/cases/9/1.png';
import case9img2 from '../images/cases/9/2.png';
import case9img3 from '../images/cases/9/3.png';

import case10img1 from '../images/cases/10/1.png';
import case10img2 from '../images/cases/10/2.png';
import case10img3 from '../images/cases/10/3.png';

import case11img1 from '../images/cases/11/1.png';
import case11img2 from '../images/cases/11/2.png';
import case11img3 from '../images/cases/11/3.png';


import case12img1 from '../images/cases/12/1.png';
import case12img2 from '../images/cases/12/2.png';
import case12img3 from '../images/cases/12/3.png';


const Cases = [
  {
    id: "1",
    title: "Caso 1: Luisa Fernanda López Mamoplastia simple 11/03/2025",
    images: [
      case1img1,
      case1img2,
      case1img3
    ]
  },
  {
    id: "2", 
    title: "Caso 2: Ana Marín Rinoplastia ultrasónica 3/07/2024",
    images: [
      case2img1,
      case2img2,
      case2img3
    ]
  },
  {
    id: "3",
    title: "Caso 3: Gregory Pinzón Rinoplastia ultrasónica 14/04/2025",
    images: [
      case3img1,
      case3img2,
      case3img3
    ]
  },
  {
    id: "4",
    title: "Caso 4: Rotsen Avilan Cirugia combinada: Rinoplastia y mamoplastia simple 27/02/2025",
    images: [
      case4img1,
      case4img2,
      case4img3
    ]
  },
  {
    id: "5",
    title: "Caso 5: María Fernanda Cirugía combinada: Rinoplastia, lipomarcación y mastopexia Año 2021",
    images: [
      case5img1,
    ]
  },
  {
    id: "6",
    title: "Caso 6: Daniela Durán Rinoplastia y mamoplastia simple Año 2021",
    images: [
      case6img1,
      case6img2,
      case6img3
    ]
  },
  {
    id: "7",
    title: "Caso 7: Shaday García Mamoplastia simple 06/12/2024",
    images: [
      case7img1,
      case7img2,
      case7img3
    ]
  },
  {
    id: "8",
    title: "Caso 8: Keiza Istúriz Rinoplastia 28/04/2025",
    images: [
      case8img1,
      case8img2,
      case8img3
    ]
  },
  {
    id: "9",
    title: "Caso 9: Adriana Dávila Rinoplastia 25/04/2025",
    images: [
      case9img1,
      case9img2,
      case9img3
    ]
  },
  {
    id: "10",
    title: "Caso 10: Steffania Rodríguez Mamoplastia simple 2020",
    images: [
      case10img1,
      case10img2,
      case10img3
    ]
  },
  {
    id: "11",
    title: "Caso 11: Dariangie García Rinoplastia ultrasónica 10/02/2025",
    images: [
      case11img1,
      case11img2,
      case11img3
    ]
  },
  {
    id: "12",
    title: "Caso 12: Idalys Rodríguez Mastopexia + Lipoescultura 23/08/2024",
    images: [
      case12img1,
      case12img2,
      case12img3
    ]
  },
];

export default Cases;
